import * as types from "./types";
import { combineReducers } from "redux";
import _ from "lodash";

function listaActividades(state = [], { type, payload }) {
  switch (type) {
    case types.FETCH_LISTA:
      let data = _.cloneDeep(state);
      data.push(payload);
      return data;
    case types.RESET:
      return [];
    default:
      return state;
  }
}

function detalleActividad(state = {}, { type, payload }) {
  switch (type) {
    case types.FETCH_DETALLE:
      return payload;
    case types.RESET_DETALLE:
      return {};
    default:
      return state;
  }
}

const reducer = combineReducers({
  listaActividades,
  detalleActividad
});

export default reducer;



// WEBPACK FOOTER //
// ./src/ducks/actividades/reducers.js